/**
 * TabContent Component
 *
 * Tab content container with async loading states.
 */

import React from 'react';
import { Box } from '@shopify/polaris';
import { useRevalidator } from 'react-router';

import { AsyncSection, SkeletonTable } from '../../loading';
import {
  useMonitoringTabs,
  useMonitoringActionsMenu,
} from '../../../contexts/MonitoringCenterContext';

import { ActiveAlertsTab } from './ActiveAlertsTab';
import { MonitoredProductsTab } from './MonitoredProductsTab';
import { AlertHistoryTab } from './AlertHistoryTab';

/**
 * Tab content container with async loading
 */
export function TabContent() {
  const tabs = useMonitoringTabs();
  const actionsMenu = useMonitoringActionsMenu();
  const revalidator = useRevalidator();

  return (
    <Box paddingBlockStart="200">
      <AsyncSection
        isLoading={tabs.isTabSwitching}
        isRefreshing={actionsMenu.isRefreshing && revalidator.state === 'loading'}
        skeleton={<SkeletonTable rows={5} />}
        minHeight="160px"
        refreshMessage="Refreshing data..."
      >
        <div className="tab-container">
          {/* Active Alerts Tab */}
          <div className={`tab-content ${tabs.selectedTab === 0 ? 'tab-active' : ''}`}>
            <ActiveAlertsTab />
          </div>

          {/* Monitored Products Tab */}
          <div className={`tab-content ${tabs.selectedTab === 1 ? 'tab-active' : ''}`}>
            <MonitoredProductsTab />
          </div>

          {/* Alert History Tab */}
          <div className={`tab-content ${tabs.selectedTab === 2 ? 'tab-active' : ''}`}>
            <AlertHistoryTab />
          </div>
        </div>
      </AsyncSection>
    </Box>
  );
}
